import { apiClient } from '@/app/api/client';

export interface ProductDto {
  id: string;
  name: string;
  description: string | null;
  stripe_product_id: string | null;
  is_active: boolean;
  quotas: string; // JSON string
}

export interface PriceDto {
  id: string;
  product_id: string;
  stripe_price_id: string | null;
  interval: 'month' | 'year';
  unit_amount: number;
  currency: string;
  is_active: boolean;
}

export interface UpdateProductRequest {
  name: string;
  description: string | null;
  is_active: boolean;
  quotas: string;
  stripe_product_id: string | null;
}

export interface UpdatePriceRequest {
  unit_amount: number;
  is_active: boolean;
  stripe_price_id: string | null;
  interval: 'month' | 'year';
}

export interface CreateProductRequest {
  product: Omit<ProductDto, 'is_active'> & { is_active: boolean };
  prices: (Omit<PriceDto, 'is_active'> & { is_active: boolean })[];
}

export const billingApi = {
  async getAllProducts(): Promise<ProductDto[]> {
    const { data } = await apiClient.get('/api/admin/billing/products');
    return data;
  },

  async getAllPrices(): Promise<PriceDto[]> {
    const { data } = await apiClient.get('/api/admin/billing/prices');
    return data;
  },

  async createProduct(request: CreateProductRequest): Promise<{ success: boolean }> {
    const { data } = await apiClient.post('/api/admin/billing/products', request);
    return data;
  },

  async updateProduct(id: string, product: UpdateProductRequest): Promise<ProductDto> {
    const { data } = await apiClient.put(`/api/admin/billing/products/${id}`, product);
    return data;
  },

  async updatePrice(id: string, price: UpdatePriceRequest): Promise<PriceDto> {
    const { data } = await apiClient.put(`/api/admin/billing/prices/${id}`, price);
    return data;
  },

  async deleteProduct(id: string): Promise<{ success: boolean }> {
    const { data } = await apiClient.delete(`/api/admin/billing/products/${id}`);
    return data;
  },
};

export function useBillingService() {
  return billingApi;
}
